import './styles/Terms.css';

import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import React from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TermsBodyClient from './TermsBodyClient';
import TermsBodyShopper from './TermsBodyShopper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
      style={{ maxWidth: '1920px', margin: 'auto' }}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function ScrollableTabsButtonAuto() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div
      className={classes.root}
      style={{ maxWidth: '1920px', margin: 'auto' }}
    >
      <AppBar position="static" elevation={0} color="transparent">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="none"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab
            label="Shapyer"
            disableElevation
            disableFocusRipple
            disableRipple
            {...a11yProps(0)}
          />
          <Tab
            label="Client"
            disableElevation
            disableFocusRipple
            disableRipple
            {...a11yProps(1)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} style={{ padding: '0', margin: '0' }}>
        <TermsBodyShopper />
      </TabPanel>
      <TabPanel value={value} index={1} style={{ padding: '0', margin: '0' }}>
        <TermsBodyClient />
      </TabPanel>
    </div>
  );
}
